export default "__VITE_ASSET__c1b06cb0__"